import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControlValueAccessorAdapter } from '@app/shared/utils/form-control-value-accessor.adapter';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { find } from 'lodash';

export interface ButtonGroupOption<T> {
  label?: string;
  value: T;
  disabled?: boolean;
  iconClass?: string;
  tooltip?: string;
  tooltipWithoutIcon?: string;
  count?: number;
}

@Component({
  standalone: false,
  selector: 'ti-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ButtonGroupComponent,
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: ButtonGroupComponent,
      multi: true,
    },
  ],
})
export class ButtonGroupComponent<T> extends FormControlValueAccessorAdapter<T, FormControl> implements OnInit {
  public form = new FormControl<T>(null);
  private _options: ButtonGroupOption<T>[] = [];

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.initializeValueChangeSubscription();
    this.updateValue();
  }

  @Input()
  public set options(options: ButtonGroupOption<T>[]) {
    this._options = options;
    this.updateValue();
  }

  @Input()
  set value(v) {
    this.writeValue(v);
    this.updateValue();
  }

  public get options() {
    return this._options;
  }

  public selectedChange(option: ButtonGroupOption<T>): void {
    this.form.setValue(option.value);
    this.cd.detectChanges();
  }

  public updateValue() {
    if (this.options.length > 0 && !find(this.options, (option) => option.value === this.form.value)) {
      this.form.setValue(this.options[0].value);
    }
  }
}
